import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {AdComponent} from '@lib-modules/ads/components/ad/ad.component';

@NgModule({
  declarations: [
    AdComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    AdComponent,
  ]
})
export class LibAdsModule {}
